'use strict';

var React = require('react');

var SvgPlanMinor = function SvgPlanMinor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M11 3a2 2 0 0 0-2 2v2h-1a2 2 0 0 0-2 2v2h-1a2 2 0 0 0-2 2v2c0 1.1.9 2 2 2h10a2 2 0 0 0 2-2v-10a2 2 0 0 0-2-2h-4Zm0 2h4v2h-4v-2Zm-3 4h4v2h-4v-2Zm-3 4h4v2h-4v-2Z"
  }));
};

exports.SvgPlanMinor = SvgPlanMinor;
